import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { About } from "./components/about";
// import { News } from "./components/news";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import ProjectData from "./data/letbabytalkData.json";
// import NewsData from "./data/newsData.json";
import { Project } from "./components/project";
// import { New } from "./components/new";
import { Tnc } from "./components/tnc";
import { Pp } from "./components/pp";
import { Da } from "./components/da";
import { Hackathon } from "./components/hackathon";
import { Survey } from "./components/survey";
import { Blog } from "./components/blog";
import { BlogPost } from "./components/blogPost";

import "./App.css";
import { HashRouter, Route, Routes, useLocation } from "react-router-dom";

const ScrollToTopOnRouteChange = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname]);

  return null;
};

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const [projectData, setProjectData] = useState({});
  // const [newsData, setNewsData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
    setProjectData(ProjectData);
    // setNewsData(NewsData);
  }, []);

  const Layout = ({ children }) => (
    <>
      <Navigation />
      {children}
    </>
  );

  const WithContact = ({ children }) => (
    <>
      {children}
      <Contact data={landingPageData.Contact} />
    </>
  );

  return (
    <HashRouter>
      <ScrollToTopOnRouteChange />
      <Routes>
        <Route
          path="/"
          element={
            <Layout>
              <Header data={landingPageData.Header} />
              {/* <News data={landingPageData.News} /> */}
              <About data={landingPageData.About} />
              {/* <Features data={landingPageData.Features} /> */}
              <Services data={landingPageData.Services} />
              {/* <Blog data={landingPageData.Blog} /> */}
              {/* <Testimonials data={landingPageData.Testimonials} /> */}
              <Team data={landingPageData.Team} />
              <Gallery data={landingPageData.Gallery} />
              <Contact data={landingPageData.Contact} />
            </Layout>
          }
        />

        <Route
          path="/project/:id"
          element={
            // <Layout>
            <Project data={projectData.letbabytalk} from="homepage" />
            // </Layout>
          }
        />
        {/* <Route
          path="/news/:id"
          element={
            <Layout>
              <New data={newsData.letbabytalk} />
            </Layout>
          }
        /> */}
        <Route
          path="/blog"
          element={
            <WithContact>
              <Blog />
            </WithContact>
          }
        />
        <Route
          path="/blog/:id"
          element={
            <WithContact>
              <BlogPost />
            </WithContact>
          }
        />
        <Route
          path="/termsnconditions"
          element={
            <WithContact>
              <Tnc />
            </WithContact>
          }
        />
        <Route
          path="/privacypolicy"
          element={
            <WithContact>
              <Pp />
            </WithContact>
          }
        />
        <Route
          path="/deactivateaccount"
          element={
            <WithContact>
              <Da />
            </WithContact>
          }
        />
        {/* <Route path="/hackathon" element={<Hackathon />} /> */}
        <Route
          path="/hackathon2"
          element={
            <WithContact>
              <Hackathon />
            </WithContact>
          }
        />
        <Route
          path="/survey"
          element={
            <WithContact>
              <Survey />
            </WithContact>
          }
        ></Route>
      </Routes>
    </HashRouter>
  );
};

export default App;

// https://github.com/issaafalkattan/React-Landing-Page-Template/tree/master
// https://medium.com/@rizkiprass/step-by-step-guide-deploying-a-react-app-on-aws-ec2-b2965af05aa4

// sudo service apache2 stop
